import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FirestoreCustomer } from '@jessie/commons';
import { NgIconWrapperComponent } from '../../../components/icons/ng-icon-wrapper/ng-icon-wrapper.component';

import { RouterLink } from '@angular/router';

@Component({
    selector: 'li[app-customer-list-entry]',
    templateUrl: './customer-list-entry.component.html',
    imports: [RouterLink, NgIconWrapperComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CustomerListEntryComponent {
  @Input()
  customer!: FirestoreCustomer;
}
